<template>
  <div class='sideLeftTree'>
      <div :class="hideLeftClass" @click="changeLeftTree"></div>
  </div>
</template>

<script>
    export default {
        data () {
            return {
                hideLeftClass: 'hideLeftClass hideLeftClass-show',
                isCollapse: true
            };
        },
        created () {
        },
        methods: {
            changeLeftTree () {
                if (this.isCollapse) {
                    this.isCollapse = false;
                    this.hideLeftClass = 'hideLeftClass hideLeftClass-hide';
                } else {
                    this.isCollapse = true;
                    this.hideLeftClass = 'hideLeftClass hideLeftClass-show';
                }
                this.$emit('changeLeftTree', this.isCollapse);
            }
        }
    };
</script>


<style lang="less">
  .sideLeftTree{
      .hideLeftClass {
          width: 18px;
          height: 60px;
          position: absolute;
          top: 50%;
          margin-top: -30px;
          z-index: 11;
          cursor: pointer;
      }

      .hideLeftClass-show {
          background: url(../../assets/img/process/showLeftTree1.png)  no-repeat -2px 0;
      }
      .hideLeftClass-hide {
          background: url(../../assets/img/process/hideLeftTree1.png) no-repeat -2px 0;
      }
      .hideLeftClass-show:hover {
          background: url(../../assets/img/process/showLeftTree2.png)  no-repeat -2px 0;
      }
      .hideLeftClass-hide:hover {
          background: url(../../assets/img/process/hideLeftTree2.png)  no-repeat -2px 0;
      }
  } 
     
</style>



// WEBPACK FOOTER //
// src/components/SideLeftTree/SideLeftTree.vue